webpackJsonp([29736136097905],{

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(29);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(35);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(34);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(76);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(75);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  flex: 1 0;\n  margin: 0 20px 40px 20px;\n"], ["\n  flex: 1 0;\n  margin: 0 20px 40px 20px;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  text-decoration: none;\n  :hover span {\n    transform: translateX(4px);\n  }\n  :hover h2 {\n    color: ", ";\n  }\n  h2 {\n    font-family: \"alegreya\";\n    margin: 0;\n    color: ", ";\n    transition: all 0.5s ease;\n  }\n  span {\n    margin: 0 4px;\n    font-size: 20pt;\n    color: ", ";\n    display:inline-block\n    transition: all 0.5s ease;\n  }\n"], ["\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  text-decoration: none;\n  :hover span {\n    transform: translateX(4px);\n  }\n  :hover h2 {\n    color: ", ";\n  }\n  h2 {\n    font-family: \"alegreya\";\n    margin: 0;\n    color: ", ";\n    transition: all 0.5s ease;\n  }\n  span {\n    margin: 0 4px;\n    font-size: 20pt;\n    color: ", ";\n    display:inline-block\n    transition: all 0.5s ease;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  font-style: italic;\n  font-size: 14pt;\n  color: ", ";\n"], ["\n  font-style: italic;\n  font-size: 14pt;\n  color: ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  font-size: 14pt;\n"], ["\n  font-size: 14pt;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"], ["\n  color: ", ";\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(50);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _polished = __webpack_require__(16);
	
	var _theme = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Title = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject2, (0, _polished.lighten)(0.1, _theme.colors.primary), _theme.colors.primary, _theme.colors.secondary);
	
	var Date = _styledComponents2.default.span(_templateObject3, _theme.colors.medium);
	
	var Description = _styledComponents2.default.span(_templateObject4);
	
	var Separator = _styledComponents2.default.span(_templateObject5, _theme.colors.medium);
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: props.insight.frontmatter.path },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: props.insight.frontmatter.image.childImageSharp.sizes })
	    ),
	    _react2.default.createElement(
	      Title,
	      { to: props.insight.frontmatter.path },
	      _react2.default.createElement(
	        "h2",
	        null,
	        props.insight.frontmatter.title
	      ),
	      _react2.default.createElement(
	        "span",
	        null,
	        "\u21E8"
	      )
	    ),
	    _react2.default.createElement(
	      Date,
	      null,
	      props.insight.frontmatter.date
	    ),
	    _react2.default.createElement(
	      Separator,
	      null,
	      " \u2013 "
	    ),
	    _react2.default.createElement(
	      Description,
	      null,
	      props.insight.frontmatter.description
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Insight (props) {
	    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("g",null,React.createElement("path",{"d":"M376,136C376,61.008,314.992,0,240,0S104,61.008,104,136c0,39.56,17.496,77.12,47.272,102.84\r\n\t\t\tC146.8,243.208,144,249.272,144,256c0,6.168,2.408,11.744,6.24,16c-3.84,4.256-6.24,9.832-6.24,16c0,6.168,2.408,11.744,6.24,16\r\n\t\t\tc-3.84,4.256-6.24,9.832-6.24,16c0,10.416,6.712,19.216,16,22.528V400c0,2.152,0.88,4.16,2.36,5.64l-0.016,0.016l72,72\r\n\t\t\tc1.56,1.56,3.608,2.344,5.656,2.344c2.048,0,4.096-0.784,5.656-2.344l72-72l-0.016-0.016c1.48-1.48,2.36-3.488,2.36-5.64v-57.472\r\n\t\t\tc9.288-3.312,16-12.112,16-22.528c0-6.168-2.408-11.744-6.24-16c3.84-4.256,6.24-9.832,6.24-16c0-6.168-2.408-11.744-6.24-16\r\n\t\t\tc3.84-4.256,6.24-9.832,6.24-16c0-6.728-2.8-12.792-7.272-17.16C358.504,213.12,376,175.56,376,136z M240,460.688L227.312,448\r\n\t\t\th25.376L240,460.688z M268.688,432h-57.376l-30.752-30.76l11.44-7.624l19.56,13.04c2.688,1.792,6.184,1.792,8.872,0L240,393.616\r\n\t\t\tl19.56,13.04c2.688,1.792,6.184,1.792,8.872,0L288,393.616l11.44,7.632L268.688,432z M304,385.048l-11.56-7.704\r\n\t\t\tc-2.688-1.792-6.184-1.792-8.872,0L264,390.384l-19.56-13.04c-2.688-1.792-6.184-1.792-8.872,0L216,390.384l-19.56-13.04\r\n\t\t\tc-2.688-1.792-6.184-1.792-8.872,0L176,385.048V344h128V385.048z M312,328H168c-4.408,0-8-3.592-8-8c0-4.408,3.592-8,8-8h144\r\n\t\t\tc4.408,0,8,3.592,8,8C320,324.408,316.408,328,312,328z M312,296H168c-4.408,0-8-3.592-8-8c0-4.408,3.592-8,8-8h144\r\n\t\t\tc4.408,0,8,3.592,8,8C320,292.408,316.408,296,312,296z M312,264H168c-4.408,0-8-3.592-8-8c0-4.408,3.592-8,8-8h143.968\r\n\t\t\tl0.096,0.016C316.44,248.048,320,251.608,320,256C320,260.408,316.408,264,312,264z M214.976,143.016\r\n\t\t\tc1.464,1.184,3.248,1.776,5.024,1.776s3.56-0.592,5.024-1.776C234.544,135.336,240,124.024,240,112\r\n\t\t\tc0-1.848-0.176-3.672-0.424-5.48c-0.072-0.52-0.168-1.024-0.264-1.544c-0.248-1.376-0.568-2.736-0.968-4.072\r\n\t\t\tc-0.128-0.448-0.24-0.896-0.384-1.336c-0.568-1.704-1.232-3.368-2.024-4.976c-0.144-0.288-0.32-0.56-0.472-0.856\r\n\t\t\tc-0.696-1.336-1.48-2.632-2.328-3.88c-0.144-0.216-0.248-0.456-0.4-0.672c4.68-1.552,9.864-1.552,14.544,0\r\n\t\t\tc-0.152,0.216-0.256,0.456-0.4,0.672c-0.848,1.256-1.624,2.544-2.328,3.88c-0.152,0.288-0.328,0.56-0.472,0.856\r\n\t\t\tc-0.792,1.608-1.464,3.28-2.024,4.976c-0.144,0.44-0.256,0.888-0.384,1.336c-0.392,1.336-0.712,2.696-0.968,4.072\r\n\t\t\tc-0.096,0.512-0.192,1.024-0.264,1.544c-0.264,1.808-0.44,3.632-0.44,5.48c0,12.024,5.456,23.336,14.976,31.016\r\n\t\t\tc1.464,1.184,3.248,1.776,5.024,1.776s3.56-0.592,5.024-1.776C274.544,135.336,280,124.024,280,112\r\n\t\t\tc0-1.848-0.176-3.672-0.424-5.48c-0.072-0.52-0.168-1.024-0.264-1.544c-0.248-1.376-0.568-2.736-0.968-4.072\r\n\t\t\tc-0.128-0.448-0.24-0.896-0.392-1.336c-0.568-1.704-1.232-3.368-2.024-4.976c-0.144-0.304-0.328-0.584-0.488-0.88\r\n\t\t\tc-0.688-1.32-1.456-2.592-2.288-3.832c-0.152-0.232-0.264-0.48-0.424-0.704C275.072,88.4,277.504,88,280,88\r\n\t\t\tc12.784,0,24,12.024,24,25.744c0,11.76-5.184,22.832-14.224,30.36l-30.896,25.752c-1.824,1.52-2.88,3.768-2.88,6.144v56h-32v-56\r\n\t\t\tc0-2.376-1.056-4.624-2.88-6.144l-30.896-25.752c-9.04-7.536-14.224-18.6-14.224-30.36C176,100.024,187.216,88,200,88\r\n\t\t\tc2.488,0,4.928,0.4,7.264,1.176c-0.16,0.224-0.272,0.48-0.424,0.704c-0.84,1.24-1.6,2.512-2.288,3.832\r\n\t\t\tc-0.152,0.296-0.336,0.576-0.488,0.88c-0.792,1.608-1.456,3.272-2.024,4.976c-0.144,0.44-0.256,0.896-0.392,1.336\r\n\t\t\tc-0.392,1.336-0.712,2.696-0.968,4.072c-0.096,0.512-0.192,1.024-0.264,1.544c-0.24,1.808-0.416,3.632-0.416,5.48\r\n\t\t\tC200,124.024,205.456,135.336,214.976,143.016z M216,112c0-1.592,0.224-3.152,0.536-4.688c0.08-0.368,0.16-0.744,0.256-1.104\r\n\t\t\tc0.384-1.496,0.872-2.968,1.544-4.368c0.056-0.104,0.12-0.208,0.176-0.312c0.416-0.824,0.976-1.576,1.488-2.352\r\n\t\t\tc0.512,0.776,1.072,1.528,1.488,2.352c0.048,0.104,0.12,0.2,0.176,0.304c0.672,1.392,1.16,2.864,1.544,4.368\r\n\t\t\tc0.096,0.368,0.176,0.736,0.256,1.104c0.312,1.544,0.536,3.104,0.536,4.696s-0.224,3.152-0.536,4.688\r\n\t\t\tc-0.08,0.368-0.16,0.744-0.256,1.104c-0.384,1.496-0.872,2.968-1.544,4.368c-0.048,0.104-0.12,0.208-0.176,0.312\r\n\t\t\tc-0.416,0.824-0.976,1.576-1.488,2.352c-0.512-0.776-1.072-1.528-1.488-2.352c-0.056-0.104-0.128-0.208-0.176-0.312\r\n\t\t\tc-0.672-1.4-1.16-2.872-1.544-4.368c-0.096-0.368-0.176-0.736-0.256-1.104C216.224,115.152,216,113.592,216,112z M256,112\r\n\t\t\tc0-1.592,0.224-3.152,0.536-4.688c0.08-0.368,0.16-0.744,0.256-1.104c0.384-1.496,0.872-2.968,1.544-4.368\r\n\t\t\tc0.056-0.104,0.12-0.208,0.176-0.312c0.416-0.824,0.976-1.576,1.488-2.352c0.512,0.776,1.072,1.528,1.488,2.352\r\n\t\t\tc0.048,0.104,0.12,0.2,0.176,0.304c0.672,1.392,1.16,2.864,1.544,4.368c0.096,0.368,0.176,0.736,0.256,1.104\r\n\t\t\tc0.312,1.544,0.536,3.104,0.536,4.696s-0.224,3.152-0.536,4.688c-0.08,0.368-0.16,0.744-0.256,1.104\r\n\t\t\tc-0.384,1.496-0.872,2.968-1.544,4.368c-0.048,0.104-0.12,0.208-0.176,0.312c-0.416,0.824-0.976,1.576-1.488,2.352\r\n\t\t\tc-0.512-0.776-1.072-1.528-1.488-2.352c-0.056-0.104-0.128-0.208-0.176-0.312c-0.672-1.4-1.16-2.872-1.544-4.368\r\n\t\t\tc-0.096-0.368-0.176-0.736-0.256-1.104C256.224,115.152,256,113.592,256,112z M311.824,232H272v-52.256l28.016-23.352\r\n\t\t\tC312.72,145.816,320,130.264,320,113.744C320,91.12,301.68,72,280,72c-7.104,0-13.912,1.952-20.024,5.576\r\n\t\t\tc-12.312-7.136-27.624-7.136-39.944,0C213.912,73.952,207.104,72,200,72c-21.68,0-40,19.12-40,41.744\r\n\t\t\tc0,16.52,7.28,32.072,19.984,42.656L208,179.744V232h-39.824C137.96,209.344,120,173.68,120,136c0-66.168,53.832-120,120-120\r\n\t\t\ts120,53.832,120,120C360,173.68,342.04,209.344,311.824,232z"}))),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("rect",{"x":"361.368","y":"16.013","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 95.4905 278.5592)","width":"45.256","height":"16"}))),React.createElement("g",{"key":2},React.createElement("g",null,React.createElement("rect",{"x":"375.986","y":"225.358","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -62.8857 344.1524)","width":"16","height":"45.256"}))),React.createElement("g",{"key":3},React.createElement("g",null,React.createElement("rect",{"x":"400","y":"128","width":"48","height":"16"}))),React.createElement("g",{"key":4},React.createElement("g",null,React.createElement("rect",{"x":"88.002","y":"1.376","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 11.1452 74.9142)","width":"16","height":"45.256"}))),React.createElement("g",{"key":5},React.createElement("g",null,React.createElement("rect",{"x":"73.373","y":"239.996","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -147.2421 140.5192)","width":"45.256","height":"16"}))),React.createElement("g",{"key":6},React.createElement("g",null,React.createElement("rect",{"x":"32","y":"128","width":"48","height":"16"}))),React.createElement("g",{"key":7},React.createElement("g",null,React.createElement("rect",{"x":"336","y":"384","width":"16","height":"16"}))),React.createElement("g",{"key":8},React.createElement("g",null,React.createElement("rect",{"x":"368","y":"384","width":"16","height":"16"}))),React.createElement("g",{"key":9},React.createElement("g",null,React.createElement("rect",{"x":"400","y":"384","width":"16","height":"16"}))),React.createElement("g",{"key":10},React.createElement("g",null,React.createElement("rect",{"x":"64","y":"384","width":"16","height":"16"}))),React.createElement("g",{"key":11},React.createElement("g",null,React.createElement("rect",{"x":"96","y":"384","width":"16","height":"16"}))),React.createElement("g",{"key":12},React.createElement("g",null,React.createElement("rect",{"x":"128","y":"384","width":"16","height":"16"}))),React.createElement("g",{"key":13}),React.createElement("g",{"key":14}),React.createElement("g",{"key":15}),React.createElement("g",{"key":16}),React.createElement("g",{"key":17}),React.createElement("g",{"key":18}),React.createElement("g",{"key":19}),React.createElement("g",{"key":20}),React.createElement("g",{"key":21}),React.createElement("g",{"key":22}),React.createElement("g",{"key":23}),React.createElement("g",{"key":24}),React.createElement("g",{"key":25}),React.createElement("g",{"key":26}),React.createElement("g",{"key":27})]);
	}
	
	Insight.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 480 480","style":{"enableBackground":"new 0 0 480 480"},"xmlSpace":"preserve"};
	
	module.exports = Insight;
	
	Insight.default = Insight;


/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.insightsQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  padding: 40px 0 0 0;\n"], ["\n  background: ", ";\n  padding: 40px 0 0 0;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  display: flex;\n  margin: 0 -20px;\n  max-width: 960px;\n  margin: auto;\n  @media (max-width: 600px) {\n    flex-direction: column;\n  }\n"], ["\n  background: ", ";\n  display: flex;\n  margin: 0 -20px;\n  max-width: 960px;\n  margin: auto;\n  @media (max-width: 600px) {\n    flex-direction: column;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(6);
	
	var _PageHeader = __webpack_require__(28);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _InsightCard = __webpack_require__(247);
	
	var _InsightCard2 = _interopRequireDefault(_InsightCard);
	
	var _insight = __webpack_require__(578);
	
	var _insight2 = _interopRequireDefault(_insight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var InsightWrapper = _styledComponents2.default.div(_templateObject, _theme.colors.white);
	
	var InsightGrid = _styledComponents2.default.div(_templateObject2, _theme.colors.white);
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Acclimate | Insights"
	      )
	    ),
	    _react2.default.createElement(
	      _PageHeader2.default,
	      null,
	      _react2.default.createElement(_insight2.default, null),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Featured ",
	          _react2.default.createElement(
	            "span",
	            null,
	            "insights"
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Our thinking on how businesses can succeed using the latest technology."
	        )
	      )
	    ),
	    _react2.default.createElement(
	      InsightWrapper,
	      null,
	      _react2.default.createElement(
	        InsightGrid,
	        null,
	        data.allMarkdownRemark.edges.map(function (insight) {
	          return _react2.default.createElement(_InsightCard2.default, { insight: insight.node });
	        })
	      )
	    )
	  );
	};
	
	var insightsQuery = exports.insightsQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-insights-js-65e93f1656194c182c5e.js